import type { ResultOf } from "@graphql-typed-document-node/core";

import { TransactionStatus } from "../../../../../schema.dev-sdk-api-appsync.generated";
import * as transport from "../../../../transport";
import type { PurchaseWithVirtualTerminal } from "../purchase-with-virtual-terminal";

const resolve = transport.Resolve<"Terminal_purchase">();

export function response_fromTransactionResponse(
	value: TransactionResponse,
	extra: {
		externalReference: string;
		sessionUuid: string | undefined;
	},
): ReturnType<typeof resolve.$Ok> {
	return resolve.$Ok({
		$type: "Approved",
		type: "PURCHASE",
		amount: value.amount,
		currency: value.currency ?? "AUD",
		scheme: value.scheme,
		transactionUuid: value.id,
		timestampLocal: value.timestamp,

		// REQUIRED BY SCHEMA BUT NULLABLE ON QUERY RESPONSE
		caid: value.caid ?? "",
		responseCode: value.responseCode ?? "",
		responseText: value.responseDescription ?? "",
		externalReference: value.externalReference || extra.externalReference,

		// OPTIONAL ON SCHEMA, NEVER TRANSMITTED TO BACKEND
		sessionUuid: extra.sessionUuid,

		// AGREED TO BE MADE OPTIONAL BY CORE SCHEMA CHANGE
		catid: value.catid ?? "",

		// REMAP REQUIRED. QUERY RESPONSE RETURNS: APPROVED,
		// DECLINED, DELETED, PROCESSING. -- BUT SCHEME ONLY
		// ACCEPTS: APPROVED, DECLINED, FAILED.
		status:
			value.status === TransactionStatus.APPROVED
				? "APPROVED"
				: value.status === TransactionStatus.DECLINED
					? "DECLINED"
					: "FAILED",

		// REMAP REQUIRED. QUERY RESPONSE RETURNS TAXAMOUNTS
		// ARRAY. ASSUMING WE SUM ALL AMOUNT VALUES.
		taxAmount:
			value.taxAmounts?.reduce((acc, { amount }) => acc + amount, 0) ?? 0,
		tipAmount: value.tipAmount,
		surchargeAmount: value.surchargeAmount,

		// OPTIONAL ON SCHEMA, REMAPPING NULL TO UNDEFINED
		cardMedia: value.cardMedia ?? undefined,
		cardholderUuid: value.cardholderUuid ?? undefined,
		panMasked: value.maskedPan ?? undefined,
		rrn: value.reference ?? undefined,

		// OPTIONAL ON SCHEMA, NOT AVAILABLE ON RESPONSE
		receiptLink: undefined,
		receiptText: undefined,
		cvm: undefined,
		aid: undefined, // Closest is .emvAid
		approvalCode: undefined,
		bin: undefined,
		emvTagsPrint: undefined,
	});
}

type TransactionResponse = ResultOf<
	typeof PurchaseWithVirtualTerminal.getTransaction
>["getTransaction"];
